import CharityRepository from "./CharityRepository";
export default {
  verifyCharity(ein) {
    return CharityRepository.get(`${ein}`);
  },
};
